export default __webpack_public_path__ + "static/media/bankAccounts.b31263c0.jpg";